import routes from "@/routers/routes";
import AvatarCard from "@/ui/avatar-card";
import DateCell from "@/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox, Text } from "rizzui";
import { getStatusBadge } from "@/components/table-utils/get-status-badge";
import TableRowActionGroup from "@/components/table-utils/table-row-action-group";
import { InvoiceTableDataType } from "./table";

const columnHelper = createColumnHelper<InvoiceTableDataType>();

export const invoiceListColumns = [
  columnHelper.display({
    id: "select",
    size: 50,
    header: ({ table }) => (
      <Checkbox
        className="ps-3"
        aria-label="Select All"
        checked={table.getIsAllPageRowsSelected()}
        onChange={table.getToggleAllPageRowsSelectedHandler()}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        className="ps-3"
        aria-label="Select Row"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
      />
    ),
  }),
  columnHelper.accessor("name", {
    id: "name",
    size: 250,
    header: "Customer",
    enableSorting: false,
    cell: ({ row }) => (
      <AvatarCard
        src={row.original.avatar}
        name={row.original.name}
        description={`INV-${row.original.id}`}
      />
    ),
  }),
  columnHelper.display({
    id: "email",
    size: 280,
    header: "Email",
    cell: ({ row }) => row.original.email.toLowerCase(),
  }),
  columnHelper.accessor("createdAt", {
    id: "createdAt",
    size: 200,
    header: "Created",
    cell: ({ row }) => <DateCell date={new Date(row.original.createdAt)} />,
  }),
  columnHelper.accessor("dueDate", {
    id: "dueDate",
    size: 200,
    header: "Due Date",
    cell: ({ row }) => <DateCell date={new Date(row.original.dueDate)} />,
  }),
  columnHelper.accessor("amount", {
    id: "amount",
    size: 200,
    header: "Amount",
    cell: ({ row }) => (
      <Text className="text-sm font-medium">${row.original.amount}</Text>
    ),
  }),
  columnHelper.accessor("status", {
    id: "status",
    size: 150,
    header: "Status",
    enableSorting: false,
    cell: ({ row }) => getStatusBadge(row.original.status),
  }),
  columnHelper.display({
    id: "actions",
    size: 120,
    cell: ({
      row,
      table: {
        options: { meta },
      },
    }) => (
      <TableRowActionGroup
        editUrl={routes.invoice.edit(row.original.id)}
        viewUrl={routes.invoice.details(row.original.id)}
        onDelete={() => {
          meta?.handleDeleteRow?.(row.original);
        }}
      />
    ),
  }),
];
